export interface MonthsRange {
  from: number | undefined
  to: number | undefined
}

export const getMonthsRangeDuration = (value: MonthsRange) => {
  const { from, to } = value
  if (!from || !to) {
    return 0
  }
  if (to >= from) {
    return to - from + 1
  }
  return 12 - from + to + 1
}
